'use client'
import { classMerge } from '@components/utilities/classMerge'
import { faCirclePlay } from '@fortawesome/pro-regular-svg-icons/faCirclePlay'
import { trackEvent } from '@lib/tracking'
import { TrackingEvents } from '@lib/tracking/TrackingEvents'
import type { TrackingSources } from '@lib/tracking/TrackingSources'
import { useInView } from 'react-intersection-observer'
import YouTube from 'react-youtube'

import { Icon } from '../Icon'
import styles from './styles.module.scss'

interface VideoPlayerProps {
  containerClassName?: string
  options?: Object
  trackingSource: TrackingSources
  videoId: string
  width?: string
}

export default function VideoPlayer(props: VideoPlayerProps) {
  const { inView, ref } = useInView({ threshold: 0, triggerOnce: true })

  const handleVideoPlay = () => {
    trackEvent(TrackingEvents.VIDEO_PLAYED, {
      source: props.trackingSource,
    })
  }

  const maxWidth = props.width ? props.width : 'max-w-[600px]'

  return (
    <div className={props.containerClassName} ref={ref}>
      <div className={classMerge('mx-auto', maxWidth)}>
        {inView ? (
          <YouTube
            className={styles.responsiveYoutube}
            loading='lazy'
            onPlay={handleVideoPlay}
            opts={props.options}
            videoId={props.videoId}
          />
        ) : (
          <div className='bg-organicDawn flex h-[175px] items-center justify-center rounded sm:h-[337px]'>
            <Icon className='text-white' icon={faCirclePlay} size='7x' />
          </div>
        )}
      </div>
    </div>
  )
}
